function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { ItemList } from '@deephaven/components';
import Log from '@deephaven/log';
import { RangeUtils } from '@deephaven/utils';
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { isDirectory } from "./FileStorage.js";
import "./FileList.css";
import { DEFAULT_ROW_HEIGHT, getMoveOperation } from "./FileListUtils.js";
import { FileListItem } from "./FileListItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('FileList');
// How long you need to hover over a directory before it expands
var DRAG_HOVER_TIMEOUT = 500;
var ITEM_LIST_CLASS_NAME = 'item-list-scroll-pane';

/**
 * Component that displays and allows interaction with the file system in the provided FileStorageTable.
 */
export function FileList(props) {
  var _props$isMultiSelect = props.isMultiSelect,
    isMultiSelect = _props$isMultiSelect === void 0 ? false : _props$isMultiSelect,
    table = props.table,
    _props$onFocusChange = props.onFocusChange,
    onFocusChange = _props$onFocusChange === void 0 ? () => undefined : _props$onFocusChange,
    onMove = props.onMove,
    onSelect = props.onSelect,
    _props$onSelectionCha = props.onSelectionChange,
    onSelectionChange = _props$onSelectionCha === void 0 ? () => undefined : _props$onSelectionCha,
    _props$renderItem = props.renderItem,
    renderItem = _props$renderItem === void 0 ? FileListItem : _props$renderItem,
    _props$rowHeight = props.rowHeight,
    rowHeight = _props$rowHeight === void 0 ? DEFAULT_ROW_HEIGHT : _props$rowHeight,
    _props$overscanCount = props.overscanCount,
    overscanCount = _props$overscanCount === void 0 ? ItemList.DEFAULT_OVERSCAN : _props$overscanCount;
  var _useState = useState(() => ({
      items: [],
      offset: 0,
      itemCount: 0
    })),
    _useState2 = _slicedToArray(_useState, 2),
    loadedViewport = _useState2[0],
    setLoadedViewport = _useState2[1];
  var _useState3 = useState({
      top: 0,
      bottom: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    viewport = _useState4[0],
    setViewport = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    dropTargetItem = _useState6[0],
    setDropTargetItem = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    draggedItems = _useState8[0],
    setDraggedItems = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    dragPlaceholder = _useState0[0],
    setDragPlaceholder = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedRanges = _useState10[0],
    setSelectedRanges = _useState10[1];
  var focusedIndex = useRef();
  var itemList = useRef(null);
  var fileList = useRef(null);
  var getItems = useCallback(ranges => {
    if (ranges.length === 0 || loadedViewport == null) {
      return [];
    }
    var items = [];
    for (var i = 0; i < ranges.length; i += 1) {
      var range = ranges[i];
      for (var j = range[0]; j <= range[1]; j += 1) {
        if (j >= loadedViewport.offset && j < loadedViewport.offset + loadedViewport.items.length) {
          items.push(loadedViewport.items[j - loadedViewport.offset]);
        }
      }
    }
    return items;
  }, [loadedViewport]);
  var getItem = useCallback(itemIndex => {
    var items = getItems([[itemIndex, itemIndex]]);
    if (items.length > 0) {
      return items[0];
    }
  }, [getItems]);

  /**
   * Get the placeholder text to show when a drag operation is in progress
   */
  var getDragPlaceholderText = useCallback(() => {
    var count = RangeUtils.count(selectedRanges);
    if (count === 0) {
      return null;
    }
    if (count === 1) {
      var index = selectedRanges[0][0];
      var item = getItem(index);
      if (item != null) {
        return item.filename;
      }
    }
    return "".concat(count, " items");
  }, [getItem, selectedRanges]);

  /**
   * Drop the currently dragged items at the currently set drop target.
   * If an itemIndex is provided, focus that index after the drop.
   */
  var dropItems = useCallback(itemIndex => {
    if (!draggedItems || !dropTargetItem) {
      return;
    }
    log.debug('dropItems', draggedItems, 'to', itemIndex);
    try {
      var _getMoveOperation = getMoveOperation(draggedItems, dropTargetItem),
        files = _getMoveOperation.files,
        targetPath = _getMoveOperation.targetPath;
      onMove === null || onMove === void 0 || onMove(files, targetPath);
      if (itemIndex != null) {
        var _itemList$current;
        setSelectedRanges([[itemIndex, itemIndex]]);
        (_itemList$current = itemList.current) === null || _itemList$current === void 0 || _itemList$current.focusItem(itemIndex);
      }
    } catch (err) {
      log.error('Unable to complete move', err);
    }
  }, [draggedItems, dropTargetItem, onMove]);
  var handleSelect = useCallback((itemIndex, event) => {
    var item = loadedViewport.items[itemIndex - loadedViewport.offset];
    if (item !== undefined) {
      log.debug('handleItemClick', item);
      onSelect(item, event);
      if (isDirectory(item)) {
        table === null || table === void 0 || table.setExpanded(item.filename, !item.isExpanded);
      }
    }
  }, [loadedViewport, onSelect, table]);
  var handleItemDragStart = useCallback((itemIndex, e) => {
    var _itemList$current2, _getDragPlaceholderTe;
    log.debug2('handleItemDragStart', itemIndex, selectedRanges);
    var draggedRanges = selectedRanges;
    if (!RangeUtils.isSelected(selectedRanges, itemIndex)) {
      draggedRanges = [[itemIndex, itemIndex]];
      setSelectedRanges(draggedRanges);
    }
    setDraggedItems(getItems(draggedRanges));

    // We need to reset reset the mouse state since we steal the drag
    (_itemList$current2 = itemList.current) === null || _itemList$current2 === void 0 || _itemList$current2.resetMouseState();
    var newDragPlaceholder = document.createElement('div');
    var dndPlaceholderContent = document.createElement('div');
    dndPlaceholderContent.className = 'dnd-placeholder-content';
    dndPlaceholderContent.innerText = (_getDragPlaceholderTe = getDragPlaceholderText()) !== null && _getDragPlaceholderTe !== void 0 ? _getDragPlaceholderTe : '';
    newDragPlaceholder.appendChild(dndPlaceholderContent);
    newDragPlaceholder.className = 'file-list-dnd-placeholder';
    document.body.appendChild(newDragPlaceholder);
    e.dataTransfer.setDragImage(newDragPlaceholder, 0, 0);
    e.dataTransfer.effectAllowed = 'move';
    setDragPlaceholder(newDragPlaceholder);
  }, [getDragPlaceholderText, getItems, selectedRanges]);
  var handleItemDragOver = useCallback((itemIndex, e) => {
    e.preventDefault();
    log.debug2('handleItemDragOver', e);
    setDropTargetItem(getItem(itemIndex));
  }, [getItem]);
  var handleItemDragEnd = useCallback((itemIndex, e) => {
    log.debug('handleItemDragEnd', itemIndex);
    dragPlaceholder === null || dragPlaceholder === void 0 || dragPlaceholder.remove();

    // Drag end is triggered after drop
    // Also drop isn't triggered if drag end is outside of the list
    setDraggedItems(undefined);
    setDropTargetItem(undefined);
    setDragPlaceholder(undefined);
  }, [dragPlaceholder]);
  var handleItemDrop = useCallback((itemIndex, e) => {
    dropItems(itemIndex);
  }, [dropItems]);
  var handleItemDragExit = useCallback(() => {
    log.debug2('handleItemDragExit');
    setDropTargetItem(undefined);
  }, []);
  var handleListDragOver = useCallback(e => {
    if (e.target instanceof Element && e.target.classList.contains(ITEM_LIST_CLASS_NAME)) {
      // Need to prevent default to enable drop
      // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#droptargets
      e.preventDefault();
      log.debug2('handleListDragOver', e);
      setDropTargetItem({
        type: 'directory',
        filename: '/',
        basename: '/',
        id: '/'
      });
    }
  }, []);
  var handleListDrop = useCallback(e => {
    if (e.target instanceof Element && e.target.classList.contains(ITEM_LIST_CLASS_NAME)) {
      log.debug('handleListDrop');
      dropItems();
    }
  }, [dropItems]);
  var handleSelectionChange = useCallback(function (newSelectedRanges) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    log.debug2('handleSelectionChange', newSelectedRanges);
    if (force === true || newSelectedRanges !== selectedRanges) {
      setSelectedRanges(newSelectedRanges);
      var selectedItems = getItems(newSelectedRanges);
      onSelectionChange(selectedItems);
    }
  }, [getItems, onSelectionChange, selectedRanges]);
  var handleFocusChange = useCallback(focusIndex => {
    log.debug2('handleFocusChange', focusIndex);
    if (focusIndex != null) {
      var _getItems = getItems([[focusIndex, focusIndex]]),
        _getItems2 = _slicedToArray(_getItems, 1),
        focusedItem = _getItems2[0];
      onFocusChange(focusedItem);
    } else {
      onFocusChange();
    }
    focusedIndex.current = focusIndex;
  }, [getItems, onFocusChange]);
  var handleViewportChange = useCallback((top, bottom) => {
    log.debug('handleViewportChange', top, bottom);
    if (top !== viewport.top || bottom !== viewport.bottom) {
      setViewport({
        top,
        bottom
      });
    }
  }, [viewport]);
  var isDropTargetValid = useMemo(() => {
    if (!draggedItems || !dropTargetItem) {
      return false;
    }
    try {
      getMoveOperation(draggedItems, dropTargetItem);
      log.debug('handleValidateDropTarget true');
      return true;
    } catch (e) {
      log.debug('handleValidateDropTarget false');
      return false;
    }
  }, [draggedItems, dropTargetItem]);
  var focusedPath = props.focusedPath;
  useEffect(() => {
    if (focusedPath !== undefined) {
      if (focusedPath === '/') {
        table.collapseAll();
      } else {
        table.setExpanded(focusedPath, false);
        table.setExpanded(focusedPath, true);
      }
    }
  }, [table, focusedPath]);
  useEffect(function updateTableViewport() {
    log.debug('updating table viewport', viewport);
    table === null || table === void 0 || table.setViewport({
      top: Math.max(0, viewport.top - overscanCount),
      bottom: viewport.bottom + overscanCount
    });
  }, [overscanCount, table, viewport]);

  // Listen for table updates
  useEffect(function setLoadedViewportAndReturnCleanup() {
    var listenerRemover = table.onUpdate(newViewport => {
      setLoadedViewport({
        items: newViewport.items.map(item => _objectSpread(_objectSpread({}, item), {}, {
          itemName: item.basename
        })),
        offset: newViewport.offset,
        itemCount: table.size
      });
    });
    return () => {
      listenerRemover();
    };
  }, [table]);

  // if the loadedViewport changes, re-fire the focused
  // item and the selected range items as they could have
  // been updated
  useEffect(function updateFocusAndSelection() {
    if (focusedIndex.current != null) {
      handleFocusChange(focusedIndex.current);
    }
    if (selectedRanges.length > 0) {
      // force the update, as the selected range may be the same
      // but the selected items may now be different
      handleSelectionChange(selectedRanges, true);
    }
  }, [loadedViewport, handleFocusChange, handleSelectionChange, selectedRanges]);

  // Expand a folder if hovering over it
  useEffect(function expandFolderOnHover() {
    if (dropTargetItem != null && isDirectory(dropTargetItem) && dropTargetItem.filename !== '/') {
      var timeout = setTimeout(() => {
        if (!dropTargetItem.isExpanded) {
          table === null || table === void 0 || table.setExpanded(dropTargetItem.filename, true);
        }
      }, DRAG_HOVER_TIMEOUT);
      return () => clearTimeout(timeout);
    }
  }, [dropTargetItem, table]);
  var renderWrapper = useCallback(itemProps => renderItem(_objectSpread(_objectSpread({}, itemProps), {}, {
    isDragInProgress: draggedItems != null,
    dropTargetItem,
    draggedItems,
    isDropTargetValid,
    onDragStart: handleItemDragStart,
    onDragEnd: handleItemDragEnd,
    onDragOver: handleItemDragOver,
    onDragExit: handleItemDragExit,
    onDrop: handleItemDrop
  })), [handleItemDragEnd, handleItemDragExit, handleItemDragOver, handleItemDragStart, handleItemDrop, draggedItems, dropTargetItem, isDropTargetValid, renderItem]);
  return /*#__PURE__*/_jsx("div", {
    ref: fileList,
    className: classNames('file-list', {
      'is-dragging': draggedItems != null
    }),
    onDragOver: handleListDragOver,
    onDrop: handleListDrop,
    children: /*#__PURE__*/_jsx(ItemList, {
      ref: itemList,
      items: loadedViewport.items,
      itemCount: loadedViewport.itemCount,
      offset: loadedViewport.offset,
      onFocusChange: handleFocusChange,
      onSelect: handleSelect,
      onSelectionChange: handleSelectionChange,
      onViewportChange: handleViewportChange,
      selectedRanges: selectedRanges,
      renderItem: renderWrapper,
      rowHeight: rowHeight,
      isMultiSelect: isMultiSelect,
      isDragSelect: false,
      isDeselectOnClick: false
    })
  });
}
export default FileList;
//# sourceMappingURL=FileList.js.map